import { type FC } from 'react'
import styles from './patients.module.scss'
import { Icon } from '@iconify/react'

type Props = {
  isLoading: boolean
  handleClick: () => void
}

export const ResolveButton: FC<Props> = ({ isLoading, handleClick }) => {
  return (
    <button
      className={styles.actionButton}
      disabled={isLoading}
      onClick={isLoading ? undefined : handleClick}
      style={isLoading ? { opacity: 0.5, cursor: 'not-allowed' } : {}}>
      <span className={styles.actionLabel}>Resolve</span>
      <span className={styles.actionIcon}>
        <Icon icon='mdi:arrow-right' />
      </span>
    </button>
  )
}
